export const Props = () => ({
  //Имя раздела
  name: {
    type: String,
    required: false,
  },

  //Описание раздела
  description: {
    type: String,
    required: false,
  },

  //Отмечен ли элемент?
  checked: {
    type: Boolean,
    required: false,
  }
});
